import React, { Component } from 'react';
import classnames from 'classnames';
import { bool, string, arrayOf, object, func } from 'prop-types';

import Carousel from 'common/Carousel/Carousel';
import CarouselPagination from 'elements/Pagination/CarouselPagination/CarouselPagination';
import ActionIcon from 'elements/ActionIcons/ActionIcon';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import ArticleCard from '../ArticleCard/ArticleCard';
import { isMobileHOC } from 'common/utils';

import styles from './TypeA.css';

class TypeA extends Component {
  constructor (props) {
    super(props);

    this.totalSlides = props.articles.length;
  }

  static propTypes = {
    className: string,
    label: string,
    pageLink: string,
    pageCallback: func,
    highlighted: string,
    description: string,
    articles: arrayOf(object),
    isMobile: bool
  }

  state = {
    activeSlide: null
  }

  swiper = null;

  onMountSwiper = (instance) => {
    this.swiper = instance;

    this.getSwiperDetails();

    this.swiper.on('slideChange', this.getSwiperDetails); 
  }

  getSwiperDetails = () => {
    this.setState({
      activeSlide: this.swiper.realIndex + 1
    });
  }

  onDismountSwiper = () => this.swiper.off('slideChange', this.getSwiperDetails);

  carouselHandler = ({ currentPage }) => {
    this.setState({ activeSlide: currentPage });
    this.swiper.slideToLoop(currentPage - 1);
  }

  renderArticlesSlider = () => {
    const options = {
      unit: true,
      loop: true
    };

    return (
      <Carousel
        className={styles.swipperContainer}
        options={options}
        onMount={this.onMountSwiper}
        onDismount={this.onDismountSwiper}
      >
        {this.renderArticles()}
      </Carousel>
    );
  }

  renderArticlesContainer = () => (
    <ul className={styles.container}>
      {this.renderArticles()}
    </ul>
  );

  renderArticles = () => {
    const { articles, isMobile } = this.props;

    return articles.map((article, i) => (
      <li className={classnames(styles.cardWrapper, { 'swiper-slide': isMobile })} key={`article-${i}`}> 
        <ArticleCard imgClass={styles.imgPlaceholder} {...article} />
      </li>
    ));
  }

  render () {
    const { activeSlide } = this.state;
    const { isMobile, className, label, highlighted, description, pageLink, pageCallback } = this.props;

    return (
      <section className={classnames(styles.articles, className)}>
        <div className={styles.head}>
          <p className={styles.labelTitle}>{label}</p>
          <LinkFreeStanding
            className={styles.link}
            icon={{ direction: 'right', name: 'arrow-right', type: '20' }}
            onClick={pageCallback}
            withBouncing
            size="m"
          >
            {pageLink}
          </LinkFreeStanding>
          <ActionIcon
            icon="link-arrow-right"
            type="30"
            customClasses={styles.actionIcon}
            onClick={pageCallback}
          />
        </div>
        <p className={styles.description}>
          {highlighted && <span className={styles.highlight}>{highlighted} </span>}
          {description}
        </p>

        {
          isMobile
            ? this.renderArticlesSlider()
            : this.renderArticlesContainer()
        }
        {
          isMobile  && 
            <div className={styles.sliderPagination}>
              <CarouselPagination
                autoplay
                totalItems={this.totalSlides}
                currentPage={activeSlide}
                onPageChange={this.carouselHandler}
                medium
              />
            </div>
        }
      </section>
    );
  }
}

export default isMobileHOC(TypeA);



// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/ArticlesBanner/TypeA/TypeA.js